import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';
import React from 'react';
import {DialogTitle} from '@apps-common/ui-components';

const MiniDialog = ({closeToast, title, message, actions, ...props}) => {
  return (
    <Paper elevation={2} maxWidth={535} padding={1} {...props}>
      <DialogTitle title={title} onClose={closeToast} />
      <DialogContent>
        <DialogContentText component="div" color="textPrimary">
          {message}
        </DialogContentText>
      </DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Paper>
  );
};

MiniDialog.propTypes = {
  actions: PropTypes.array,
  message: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  closeToast: PropTypes.func,
  title: PropTypes.string,
};

export default MiniDialog;
